<template>
    <div class="question-text">
        <TextArea
            v-if="question.textarea"
            :id="question.id"
            v-model="answerModel"
            :label="question.label || undefined"
            :placeholder="question.placeholder || undefined"
            class="field"
            :required="question.required"
            :focus
        />

        <TextField
            v-else
            :id="question.id"
            v-model="answerModel"
            :label="question.label || undefined"
            :placeholder="question.placeholder || undefined"
            class="field"
            :required="question.required"
            :focus
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type {
    QuestionnaireAnswerInput,
    QuestionnaireQuestionTextFragment,
} from '@/graphql/api'

import TextField from '@/components/ui/inputs/TextField.vue'
import TextArea from '@/components/ui/inputs/TextArea.vue'

const props = defineProps<{
    question: QuestionnaireQuestionTextFragment
    answer: QuestionnaireAnswerInput | undefined
    focus: boolean
}>()

const emit = defineEmits<{
    'update:answer': [answer: QuestionnaireAnswerInput | undefined]
}>()

const answerModel = computed({
    get: () => props.answer?.answer.text?.text || '',
    set: (answer) =>
        emit('update:answer', {
            answer: { text: { text: answer } },
            question: {
                referenceId: props.question.id,
                title: props.question.title,
            },
        }),
})
</script>

<style lang="scss" scoped>
.question-text {
    .field {
        margin: 0 auto;
        display: block;
        max-width: 540px;
    }
}
</style>
